import { projectSettings } from "../config";
import model from "../stores/modelStore";

export const getTealiumID = () =>
    typeof window !== 'undefined' &&
        typeof window.utag === 'object' &&
        typeof window.utag.data === 'object'
        ? window.utag.data.tealium_visitor_id
        : null;

async function hash(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
    return hashHex;
}

// Helper function that assists in asynchronously sending user data just in case
// the user interacts with the page before the Tealium scripts load. Prevents data being dropped.
const resolveUtag = async () => {
    if (window?.utag) return window?.utag;
    let i = 0;

    while (i < 50) {
        await new Promise((resolve) => setTimeout(resolve, 200));
        if (window?.utag) return window?.utag;
        i++;
    }
    return { link: () => undefined, view: () => undefined };
};

//const utagLink = (data) => console.log(data);
const utagLink = async (data) => {
    let utag = await resolveUtag();
    utag.link(data);
}

const registerFormStart = () => {
    utagLink({
        "class_action_name": projectSettings.classActionName,
        "page_url": `${window.location.hostname}${window.location.pathname}`,
        "tealium_event": "class_action_form_start"
    });
}

const registerPageComplete = (pageName) => {
    model.update(m => { m.tealiumId = getTealiumID(); return m; });

    utagLink({
        "class_action_name": projectSettings.classActionName,
        "class_action_phase_name": pageName,
        "page_url": `${window.location.hostname}${window.location.pathname}`,
        "tealium_event": "class_action_form_phase_completed"
    });
}

const registerSubmit = async (email, phone, registrationNumber) => {
    const emailHash = await hash(email);
    const phoneHash = await hash(phone);

    utagLink({
        "class_action_name": projectSettings.classActionName,
        "hashed_email": emailHash,
        "hashed_phone": phoneHash,
        "page_url": `${window.location.hostname}${window.location.pathname}`,
        "reference_number": registrationNumber,
        "tealium_event": "class_action_form_submit"
    });
}

export { registerFormStart, registerPageComplete, registerSubmit };
